import { createContext } from "react";

import { HamletClient, IHamletClient } from "@atlassiansox/asc-hamlet";

export const HamletClientContext = createContext<IHamletClient>(
    new HamletClient()
);
